module.exports = __webpack_public_path__ + "static/media/curryworst.df5b75c9.jpg";